const $ = jQuery;

const reportHeader = () => {
    const $header = $('.report-header');
    if (!$header.length) return;

    const $toggle = $header.find('.report-header__toggle');
    const $dropdown = $header.find('.report-header__dropdown');
    const $body = $('body');

    if (!$toggle.length || !$dropdown.length) return;

    $dropdown.hide();

    const openMenu = () => {
        $dropdown.slideDown(300);
        $header.addClass('is-open');
        $toggle.attr('aria-expanded', 'true');
        $body.addClass('menu-open');
    };

    const closeMenu = () => {
        $dropdown.slideUp(300);
        $header.removeClass('is-open');
        $toggle.attr('aria-expanded', 'false');
        $body.removeClass('menu-open');

        setTimeout(() => {
            $header.addClass('closing');

            setTimeout(() => {
                $header.removeClass('closing');
            }, 300);
        }, 300);
    };

    $toggle.on('click', function () {
        const isOpen = $header.hasClass('is-open');

        if (isOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    // Close menu when clicking outside
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.report-header').length && $header.hasClass('is-open')) {
            closeMenu();
        }
    });

    // Close menu on escape key
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $header.hasClass('is-open')) {
            closeMenu();
        }
    });

    // Close menu when clicking on nav links
    $dropdown.on('click', 'a', function () {
        closeMenu();
    });
};

export default reportHeader;
